var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp-scene" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pdp-scene__tabs", attrs: { role: "tablist" } },
      _vm._l(_vm.tabs, function (t) {
        return _c(
          "button",
          {
            key: t.key,
            staticClass: "pdp-scene__tab",
            class: { "is-active": _vm.activeTab === t.key },
            attrs: { type: "button", disabled: _vm.disabled || t.disabled },
            on: {
              click: function ($event) {
                _vm.activeTab = t.key
              },
            },
          },
          [_c("i", { class: t.icon }), _vm._v(" " + _vm._s(t.label) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pdp-scene__body" }, [
      _vm.activeTab === "generate"
        ? _c("div", [
            _c("p", { staticClass: "pdp-scene__hint" }, [
              _vm._v(
                "\n        I'll generate a lifestyle background from the product context.\n      "
              ),
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.generatePrompt,
                  expression: "generatePrompt",
                },
              ],
              staticClass: "pdp-scene__input",
              attrs: {
                type: "text",
                placeholder:
                  _vm.defaultScenePrompt ||
                  "e.g. on a kitchen counter at golden hour",
                disabled: _vm.disabled,
              },
              domProps: { value: _vm.generatePrompt },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.generatePrompt = $event.target.value
                },
              },
            }),
          ])
        : _vm.activeTab === "paste"
        ? _c("div", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.pasteUrl,
                  expression: "pasteUrl",
                },
              ],
              staticClass: "pdp-scene__input",
              attrs: {
                type: "text",
                placeholder: "Paste an image URL",
                disabled: _vm.disabled,
              },
              domProps: { value: _vm.pasteUrl },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.pasteUrl = $event.target.value
                },
              },
            }),
          ])
        : _vm.activeTab === "upload"
        ? _c("div", [
            _c("p", { staticClass: "pdp-scene__hint" }, [
              _vm._v(
                "\n        Direct upload coming soon — use the Files tab to pick from your library.\n      "
              ),
            ]),
          ])
        : _vm.activeTab === "files"
        ? _c("div", [
            _c("p", { staticClass: "pdp-scene__hint" }, [
              _vm._v(
                "\n        Click Composite to open the file browser.\n      "
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pdp-scene__actions" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-sm btn-primary",
          attrs: {
            type: "button",
            disabled: _vm.disabled || !_vm.canComposite,
          },
          on: { click: _vm.onComposite },
        },
        [_c("i", { staticClass: "bi bi-stars" }), _vm._v(" Composite\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "pdp-scene__skip",
          attrs: { type: "button", disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.$emit("skip")
            },
          },
        },
        [_vm._v("\n      Skip this image\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pdp-scene__header" }, [
      _c("i", { staticClass: "bi bi-image-alt" }),
      _vm._v(" "),
      _c("b", [_vm._v("Lifestyle")]),
      _vm._v(" · place product on a background\n  "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }